import { Image, Modal, Typography } from '@smartgift/frontend-toolkit';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';

import { PRODUCT_TYPES, RECOGNITIONS_TAB } from '@hero/constants';
import { UserName } from '@hero/molecules';
import { ROUTE_PATHS } from '@hero/routes';
import { convertHtmlMessageToString } from '@hero/utils';
import { formatTimeAgo } from '@hero/utils/dateUtils';

import * as S from './style';

function ThankYouDetailModal({ isOpen, onRequestClose, selectedGratitude }) {
  const { t } = useTranslation();

  const navigate = useNavigate();

  const handleRedirectToGratitude = () => {
    navigate(
      `${ROUTE_PATHS.MY_RECOGNITION_DETAIL(selectedGratitude.recognitionCode)}?initialNote=${selectedGratitude._id}#${
        RECOGNITIONS_TAB.tyNotes
      }`
    );
  };

  return (
    <Modal
      isOpen={isOpen}
      onRequestClose={onRequestClose}
      primaryButtonProps={{ onClick: handleRedirectToGratitude, children: t('seeDetails') }}
      secondaryButtonProps={{ onClick: onRequestClose, children: t('cancel') }}
      selectedGratitude={selectedGratitude}
      size="sm"
    >
      <S.ThankYouDetailModalWrapper>
        <Image
          src={selectedGratitude?.selectedSku?.images?.find(image => image.default)?.url}
          width={180}
          height={198}
          style={{
            objectFit:
              selectedGratitude?.selectedSku?.meta?.productType === PRODUCT_TYPES.GIFT_CARD
                ? 'contain'
                : 'inherit'
          }}
        />

        <S.GratitudeBoardCardInfo>
          <UserName
            firstName={selectedGratitude.recipient.firstName}
            lastName={selectedGratitude.recipient.lastName}
            hasNameAvatar
          />
          <Typography variant="caption1" emphasis="weak">
            {formatTimeAgo(selectedGratitude?.status?.acceptedAt)}
          </Typography>
        </S.GratitudeBoardCardInfo>

        <Typography variant="body1">
          {convertHtmlMessageToString(selectedGratitude?.experience?.thankYouMessage)}
        </Typography>
      </S.ThankYouDetailModalWrapper>
    </Modal>
  );
}

export { ThankYouDetailModal };

ThankYouDetailModal.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  onRequestClose: PropTypes.func.isRequired,
  selectedGratitude: PropTypes.shape({
    recognitionCode: PropTypes.string.isRequired,
    recipient: PropTypes.shape({
      firstName: PropTypes.string.isRequired,
      lastName: PropTypes.string.isRequired
    }).isRequired,
    status: PropTypes.shape({
      acceptedAt: PropTypes.string.isRequired
    }).isRequired,
    selectedSku: PropTypes.shape({
      images: PropTypes.arrayOf(
        PropTypes.shape({
          default: PropTypes.bool.isRequired,
          url: PropTypes.string.isRequired
        })
      ).isRequired,
      meta: PropTypes.shape({
        productType: PropTypes.string.isRequired
      }).isRequired
    }).isRequired,
    experience: PropTypes.shape({
      thankYouMessage: PropTypes.string.isRequired
    }).isRequired
  }).isRequired
};
